import React from 'react';
import CTAButton from '../../components/CTAButton';
import './About.css';

const About = () => {
  const timelineData = [
    {
      era: 'The Foundation',
      heading: 'Building Robust Applications',
      description: 'We began our journey by building robust mobile and web applications for clients across industries. Our early work focused on creating dependable, high-quality digital products.'
    },
    {
      era: 'The Evolution',
      heading: 'Pioneering Intelligent Systems',
      description: 'What started with cross-platform mobile development soon evolved into full-scale AI systems and scalable cloud solutions. This shift was driven by our passion for solving more complex, impactful business problems.'
    },
    {
      era: 'Today',
      heading: 'A Trusted Global Partner',
      description: 'Having grown through real-world engineering and product delivery, we have built a reputation for being dependable, innovative, and hands-on, with successful projects delivered across the USA, India, and beyond.'
    }
  ];

  const partnershipBenefits = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      heading: '100% Delivery Record',
      text: 'We have a proven track record of successfully delivering every project on time and to specification.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      heading: '24/7 Support',
      text: 'Our clients benefit from round-the-clock support to ensure their systems are always running smoothly.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.75 5.5L9 17l9 9 9-9a6 6 0 00-6-6z"/>
        </svg>
      ),
      heading: 'Complete IP Ownership',
      text: 'You retain full intellectual property ownership of the solutions we build for you.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      heading: 'Global Expertise',
      text: 'We bring a wealth of experience from successfully delivering projects for startups and enterprises in the USA, India, and beyond.'
    }
  ];

  return (
    <main>
      {/* Page Header Section */}
      <section className="page-header">
        <div className="page-header-bg">
          <div className="about-partnership-bg"></div>
        </div>
        <div className="page-header-content">
          <h1 className="page-header-title">Your Partner in Innovation</h1>
          <p className="page-header-subtitle">
            Learn about our journey, our values, and our commitment to transforming your vision into digital reality.
          </p>
        </div>
      </section>

      {/* Our Journey Section */}
      <section className="journey-section">
        <div className="container">
          <h2 className="section-title">Our Story: From Apps to AI</h2>
          <div className="timeline">
            {timelineData.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker">
                  <div className="timeline-dot"></div>
                  <div className="timeline-line"></div>
                </div>
                <div className="timeline-content">
                  <span className="timeline-era">{item.era}</span>
                  <h3 className="timeline-heading">{item.heading}</h3>
                  <p className="timeline-description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Philosophy Section */}
      <section className="philosophy-section">
        <div className="container">
          <div className="philosophy-content">
            <blockquote className="main-quote">
              "We don't just write code, we solve problems."
            </blockquote>
            <p className="philosophy-description">
              This philosophy is at the core of everything we do. We deeply understand business pain points and deliver solutions that are not only technologically advanced but are also fast, reliable, and impactful. Our commitment to quality, responsiveness, and cost-effectiveness has made us a trusted technology partner.
            </p>
          </div>
        </div>
      </section>

      {/* Why Partner With Us Section */}
      <section className="partnership-section">
        <div className="container">
          <h2 className="section-title">Our Commitment to You</h2>
          <div className="partnership-grid">
            {partnershipBenefits.map((benefit, index) => (
              <div key={index} className="partnership-benefit">
                <div className="benefit-icon">
                  {benefit.icon}
                </div>
                <h3 className="benefit-heading">{benefit.heading}</h3>
                <p className="benefit-text">{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Let's Build Together CTA Section */}
      <section className="build-together-section">
        <div className="partnership-background">
          <div className="handshake-overlay"></div>
        </div>
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-headline">Become Our Next Success Story</h2>
            <p className="cta-subtext">
              Let's transform your vision into a secure, efficient, and scalable digital reality.
            </p>
                             <CTAButton variant="primary" size="large" href="/contact">Partner With Us</CTAButton>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
